export const processPortfolioData = (data, threshold = 1) => {
    const processedData = {};
  
    Object.keys(data).forEach(portfolioName => {
      const portfolioData = data[portfolioName];
      const totalValue = Object.values(portfolioData).reduce((sum, value) => sum + value, 0);
  
      let aggregatedData = {};
      let othersTotal = 0;
  
      Object.entries(portfolioData).forEach(([coin, value]) => {
        const percentage = (value / totalValue) * 100;
        if (threshold !== 0 && percentage < threshold) {
          othersTotal += value;
        } else {
          aggregatedData[coin] = value;
        }
      });
  
      if (threshold !== 0 && othersTotal > 0) {
        aggregatedData["Others"] = othersTotal;
      }
  
      processedData[portfolioName] = aggregatedData;
    });
  
    return processedData;
  };
  